export default __webpack_public_path__ + "static/media/sensor_marker_offline.72548e3b.svg";